// Mock invoice data for Phase 0 demo - Static data to demonstrate dashboard UI concept

export interface MockInvoice {
  invoice_id: string;
  vendor_name: string;
  invoice_number: string;
  amount: number;
  aging_days: number;
  priority_level: 'high' | 'medium' | 'low';
  priority_score: number;
  duplicate_detected: boolean;
  status: 'pending' | 'approved' | 'rejected';
  invoice_date: string;
  received_date: string;
}

// Helper to generate mock invoices
const vendors = ['Fabrikam Inc', 'Contoso Ltd', 'Wide World Importers', 'Northwind Traders', 'Adventure Works', 'Litware Inc', 'Proseware Inc', 'Tailspin Toys', 'Fourth Coffee', 'Wingtip Toys'];

const generateInvoices = (): MockInvoice[] => {
  const invoices: MockInvoice[] = [];
  let id = 1;

  // HIGH PRIORITY: 45 invoices (aging > 30 days or duplicates)
  for (let i = 0; i < 45; i++) {
    const aging = 31 + Math.floor(Math.random() * 20); // 31-50 days
    const isDuplicate = i % 9 === 0; // ~10% duplicates
    invoices.push({
      invoice_id: `INV-2024-${String(id).padStart(3, '0')}`,
      vendor_name: vendors[i % vendors.length],
      invoice_number: `${vendors[i % vendors.length].substring(0, 3).toUpperCase()}-2024-${String(id).padStart(3, '0')}`,
      amount: Math.round((5000 + Math.random() * 20000) * 100) / 100,
      aging_days: aging,
      priority_level: 'high',
      priority_score: 70 + Math.floor(Math.random() * 30),
      duplicate_detected: isDuplicate,
      status: 'pending',
      invoice_date: `2024-01-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
      received_date: `2024-01-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`
    });
    id++;
  }

  // MEDIUM PRIORITY: 78 invoices (aging 8-30 days)
  for (let i = 0; i < 78; i++) {
    const aging = 8 + Math.floor(Math.random() * 23); // 8-30 days
    invoices.push({
      invoice_id: `INV-2024-${String(id).padStart(3, '0')}`,
      vendor_name: vendors[i % vendors.length],
      invoice_number: `${vendors[i % vendors.length].substring(0, 3).toUpperCase()}-2024-${String(id).padStart(3, '0')}`,
      amount: Math.round((3000 + Math.random() * 15000) * 100) / 100,
      aging_days: aging,
      priority_level: 'medium',
      priority_score: 40 + Math.floor(Math.random() * 30),
      duplicate_detected: false,
      status: 'pending',
      invoice_date: `2024-02-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
      received_date: `2024-02-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`
    });
    id++;
  }

  // LOW PRIORITY: 127 invoices (aging 0-7 days)
  for (let i = 0; i < 127; i++) {
    const aging = Math.floor(Math.random() * 8); // 0-7 days
    invoices.push({
      invoice_id: `INV-2024-${String(id).padStart(3, '0')}`,
      vendor_name: vendors[i % vendors.length],
      invoice_number: `${vendors[i % vendors.length].substring(0, 3).toUpperCase()}-2024-${String(id).padStart(3, '0')}`,
      amount: Math.round((1000 + Math.random() * 10000) * 100) / 100,
      aging_days: aging,
      priority_level: 'low',
      priority_score: Math.floor(Math.random() * 40),
      duplicate_detected: false,
      status: 'pending',
      invoice_date: `2024-03-${String(Math.floor(Math.random() * 11) + 1).padStart(2, '0')}`,
      received_date: `2024-03-${String(Math.floor(Math.random() * 11) + 1).padStart(2, '0')}`
    });
    id++;
  }

  return invoices;
};

export const mockInvoices: MockInvoice[] = generateInvoices();

// Summary statistics
export const mockSummary = {
  total: mockInvoices.length,
  high: mockInvoices.filter(inv => inv.priority_level === 'high').length,
  medium: mockInvoices.filter(inv => inv.priority_level === 'medium').length,
  low: mockInvoices.filter(inv => inv.priority_level === 'low').length,
  duplicates: mockInvoices.filter(inv => inv.duplicate_detected).length,
  lastBatchRun: '2024-03-11T02:15:00Z'
};
